import React, { Component } from 'react';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Typography, Box, Link, Button } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { push } from 'connected-react-router';

class LoginSAML extends Component {
	render() {
		const { translate, push } = this.props;
    const { protocol, host } = window.location;

		if (this.props.meeting.token) {
			return (
				<Box>
					<Typography>{translate('login_saml_information')}</Typography>
					<Box id="login-saml" pb={1} pt={2} display="flex" justifyContent="center" alignItems="center">
						<Button
							component="a"
							onClick={() => {
								window.location.href = `/api/auth/saml/login?return_to=${protocol}//${host}/meetings/${this.props.meeting.token}`;
							}}
							startIcon={<LoginIcon />}
							variant="contained"
							color="primary"
						>
							{translate('login_saml_button_label')}
						</Button>
					</Box>
				</Box>
			);        
		} else {
			return (
				<Box>
					<Typography>{translate('login_saml_information')}</Typography>
					<Box id="login-saml" pb={1} pt={2} display="flex" justifyContent="center" alignItems="center">
						<Button
							component="a"
							onClick={() => {
								window.location.href = '/api/auth/saml/login';
							}}
							startIcon={<LoginIcon />}
							variant="contained"
							color="primary"
						>
							{translate('login_saml_button_label')}
						</Button>
					</Box>
				</Box>
			);
		}
	}
}

const mapStateToProps = (state) => ({
	translate: getTranslate(state.localize),
	meeting: state.meetings,
});

export default connect(mapStateToProps, {})(LoginSAML);
